module.exports = __webpack_public_path__ + "fonts/GaramontAmsterdamBQ-Medium.140022fa.ttf";